import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CompanyConfigDataService from "../../services/CompanyConfigDataService";

export const getCompanyConfigs = createAsyncThunk(
  "companyConfig/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await CompanyConfigDataService.getAll();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const companyConfigSlice = createSlice({
  name: "companyConfig",
  initialState: {
    companyConfigs: null,
    loading_companyConfigs: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyConfigs.pending, (state) => {
        state.loading_companyConfigs = true;
      })
      .addCase(getCompanyConfigs.fulfilled, (state, action) => {
        state.loading_companyConfigs = false;
        state.companyConfigs = action.payload;
      })
      .addCase(getCompanyConfigs.rejected, (state) => {
        state.loading_companyConfigs = false;
      });
  },
});

export default companyConfigSlice.reducer;